import { z } from 'zod';
import { WSIOrigin } from './wsi/wsi-passport';
import { shared } from '@tig-dpqa-cloud/contract-backend-common';

export const SlideScanToAnonymize = z.object({
  anonymizedSlideScanId: shared.AnonymizedSlideScanId,
  cloudSlideScanId: z.string().describe('Id used to retrieve the passport metadata'),
  // TODO: MI0688-3574: make the origin field optional.
  // (and remove it completely after Cedric release)
  origin: WSIOrigin,
  isPhiDetected: z
    .boolean()
    .describe('Indicates whether PHI is detected in the slide scan or not')
    .prefault(true),
});

export type SlideScanToAnonymizeType = z.infer<typeof SlideScanToAnonymize>;
